import type { FaireProductEntity } from "../../entity_types/product";

export const p_n84dby9hq5: FaireProductEntity = {
  token: "p_n84dby9hq5",
  type: "product",
  name: "Look Good Naked Makeup Kit Organic Cosmetics Beauty Gift Mom",
  brandToken: "b_cl0th8ix44",
  brandName: "Orglamix",
  imageUrl:
    "https://cdn.faire.com/fastly/070c8a96110369682e64840a891441587d6883ffb2441a870baac47a9876eca6.jpeg",
  galleryImageUrls: [],
  priceDollars: 34.5,
  description:
    "The no-makeup makeup look is probably the biggest beauty myth to date: Looking like you're barefaced actually requires a bevy of products to perfect your skin, brighten your eyes, and bring a touch of color and definition to all the right places. \n\nThese best of beauty winners will help you get there with as little effort as possible.\n\nWhat this kit includes:\n- Beauty Balm\n- Self-Adjusting Mineral Foundation in Whole Grain\n- Lip + Cheek Gelee in Love\n- Natural Eye Color in Cashmere\n- Lash Gloss\n- Orglamix Makeup Bag\n\nThis set contains: \nOver $95 value. Enjoy over 20% instant savings on this bundle - discounted pricing automatically shown in cart.",
  tags: [],
  msrpDollars: 69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:23.732Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
